import constants from "../constants";

function getLanguageCode(language: string): string {
    // Default to English
    let supportedLanguageCode = "en";

    // If there are supported languages declared
    if (constants.FEEDBACK.SUPPORTED_LANGUAGES.length) {

        // Strip regional code (fr-FR -> fr)
        const currentLanguageBaseCode = language.substring(0, 2).toLowerCase();

        if (constants.FEEDBACK.SUPPORTED_LANGUAGES.indexOf(currentLanguageBaseCode) !== -1) {
            supportedLanguageCode = currentLanguageBaseCode;
        }
    }

    return supportedLanguageCode;
}

/**
 * Builds the feedback support URL.
 * @param language - The current language code (e.g., "en", "de", "fr")
 * @returns The constructed support URL with language parameter, or empty string if no URL is configured
 */
export function getFeedbackSupportUrl(language: string): string {
    const supportedLanguageCode = getLanguageCode(language);

    return constants.FEEDBACK.EXTERNAL_SUPPORT_URL.replace("{LANGUAGE}", supportedLanguageCode);
}
